export const salesPrimaryButtonHandler = (
  status,
  isEdit,
  sendApproveHandler,
  approveHandler,
  editSubmitHandler
) => {
  if (isEdit) {
    editSubmitHandler();
  } else {
    switch (status) {
      case "draft":
        sendApproveHandler();
        break;
      case "waitApprove":
        approveHandler();
        break;
      default:
        sendApproveHandler();
    }
  }
};

export const salesSecondaryButtonHandler = (
  status,
  isEdit,
  saveDraftHandler,
  notApproveHandler,
  editCancelHandler
) => {
  if (isEdit) {
    editCancelHandler();
  } else {
    switch (status) {
      case "draft":
        saveDraftHandler();
        break;
      case "waitApprove":
        notApproveHandler();
        break;
      default:
        saveDraftHandler();
    }
  }
};

export const logisticPrimaryButtonHandler = (
  status,
  isEdit,
  sendDeliverHandler,
  editSubmitHandler
) => {
  if (isEdit) {
    editSubmitHandler();
  } else {
    switch (status) {
      case "draft":
        sendDeliverHandler();
        break;
      default:
        sendDeliverHandler();
    }
  }
};

export const logisticSecondaryButtonHandler = (
  status,
  isEdit,
  saveDraftHandler,
  editCancelHandler
) => {
  if (isEdit) {
    editCancelHandler();
  } else {
    switch (status) {
      case "draft":
        saveDraftHandler();
        break;
      default:
        saveDraftHandler();
    }
  }
};
